// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__pzMG-","content_page":"style_content_page__CQF7y"};